const getLabelFromFieldName = (fieldName: string): string => {
  const fieldNameNoUnderscores = fieldName.replace(/_/g, ' ');
  const label = fieldNameNoUnderscores.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, str => str.toUpperCase());
  return label;
};

export default getLabelFromFieldName;
